module.exports = __webpack_public_path__ + "static/media/14UNEP20.4fd3a8ac.jpg";